import axios from "axios";
const HTTP = axios.create({
  baseURL: process.env.VUE_APP_API + "/api/",
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS",
    xsrfCookieName: "XSRF-TOKEN", // default
    // `xsrfHeaderName` is the name of the http header that carries the xsrf token value
    xsrfHeaderName: "X-XSRF-TOKEN", // default
  },
});

export { HTTP };
